/*
 * MOVTECH — ingyenes konzultacio popup a Shock Wave gepet kosarba tevoknek (2026-10-21).
 * Markup: snippets/movtech-konzultacio-popup.liquid
 *
 * Feltetel: a kosarban van a data-handles listabol termek (gep vagy berles).
 * Kilepesi szandek:
 *   - gepen: az eger az ablak tetejen kimegy (fulek, cimsor, bezaras fele),
 *   - mobilon: nincs eger, ezert gyors felfele gorgetes (a menusor/vissza fele)
 *     vagy 30 mp tetlenseg.
 * Legkorabban 6 mp-cel az oldal betoltese utan, egy oldalon egyszer.
 *
 * Szabalyok: a MOVTECH ajanlatok app kapuja (window.mvtPopupSzabaly) dont a napi
 * korlatrol es arrol, hogy aki kitoltotte, annak soha tobbe nem jon fel. Ha a kapu
 * hianyzik, NEM jelenik meg (ugyanugy, mint a kviz). Masik nyitott ablak (kosar-
 * fiok, ajanlat, kviz) mellett sem nyilik meg.
 *
 * Bekuldes: gyari contact form; a movtech-form-ajax.js veszi at (helyben, ujratoltes
 * nelkul), mert nyitaskor a doboz megkapja az .active-modal-js osztalyt. Ha megis
 * a gyari, ujratolteses ut fut le, a ?contact_posted=true + sessionStorage jelzobol
 * ismerjuk fel, es megmutatjuk a koszonetet.
 */
(function () {
  "use strict";

  var NEV = "konzultacio";
  var KESLELTETES_MS = 6000;
  var TETLENSEG_MS = 30000; // Lexi 2026-10-21: 30 mp
  var KULDVE_KULCS = "mvt_konz_kuldve";
  var KOSZONET =
    "Köszönjük! Termékszakértő kollégánk 2 munkanapon belül hív. A kosarad addig is megmarad.";

  var doboz = document.getElementById("MovtechKonzultacio");
  if (!doboz) return;
  if (/[?&]view=penztar/.test(location.search)) return; // a sajat penztarban nem zavarjuk

  var urlap = doboz.querySelector("form");
  var handles = (doboz.getAttribute("data-handles") || "").split(",").map(function (h) {
    return h.trim();
  });
  var betoltve = Date.now();
  var megnyitva = false;
  var kosarTetel = null; // a kosarban talalt gep neve, ha van

  // Teszt-kapcsolo: ?konzultacio-teszt → a munkamenet vegeig nincs keslelteteas es napi korlat
  // (a „mar kitoltotte" szabaly ilyenkor is el).
  var teszt = false;
  try {
    if (/[?&]konzultacio-teszt/.test(location.search)) sessionStorage.setItem("mvt_konz_teszt", "1");
    teszt = sessionStorage.getItem("mvt_konz_teszt") === "1";
  } catch (e) {}

  function kapu() {
    return window.mvtPopupSzabaly || null;
  }

  // A kapu szabad()-ja azt is tiltja, ha barhol van .mvt-ajanlat elem a lapon (akkor is, ha
  // mar nem latszik). Itt csak a ket szabaly szamit: kitoltotte-e, es betelt-e a napi keret.
  function szabad(k) {
    var a = k.allapot();
    if ((a.kesz || {})[NEV]) return false;
    return teszt || a.db < a.napi_max;
  }

  // A kosar-fiok NEM akadaly: kosarba tetel utan nyitva van, es pont ilyenkor indulnak el.
  // Nyitaskor bezarjuk. (Az .active-modal-js es a html.open-modal a fioktol is jon, nem jo jel.)
  function masAblakNyitva() {
    return Boolean(document.querySelector(".modal.active:not(cart-drawer), .mvt-ajanlat--lathato"));
  }

  function fiokotBezar() {
    var fiok = document.querySelector("cart-drawer.modal.active");
    var gomb = fiok && fiok.querySelector(".modal-button-close");
    if (gomb) gomb.click();
  }

  function kosarEllenoriz() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (kosar) {
        var talalat = kosar && kosar.items && kosar.items.filter(function (t) {
          return handles.indexOf(t.handle) !== -1;
        });
        kosarTetel = talalat && talalat.length
          ? talalat.map(function (t) { return t.quantity + " x " + t.title; }).join(", ")
          : null;
        return Boolean(kosarTetel);
      })
      .catch(function () {
        return false;
      });
  }

  function probal() {
    if (megnyitva) return;
    if (!teszt && Date.now() - betoltve < KESLELTETES_MS) return;
    var k = kapu();
    if (!k) {
      if (window.console) console.warn("[konzultacio] a popup-kapu (mvtPopupSzabaly) hianyzik, nem nyitunk");
      return;
    }
    if (!szabad(k) || masAblakNyitva()) return;
    megnyitva = true; // egy oldalon egyszer, a kosar-lekeres alatt se nyiljon ketszer
    kosarEllenoriz().then(function (van) {
      if (!van || masAblakNyitva()) {
        megnyitva = false;
        return;
      }
      nyit();
    });
  }

  // Az ugyfelszolgalati ertesitobe: mikor kuldte be, es meddig kell visszahivni
  // (2 munkanap, a hetvege kimarad; unnepnapot nem figyelunk).
  var NAPOK = ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"];
  function datum(d, oraval) {
    var k = function (n) { return (n < 10 ? "0" : "") + n; };
    return d.getFullYear() + ". " + k(d.getMonth() + 1) + ". " + k(d.getDate()) + ". (" + NAPOK[d.getDay()] + ")" +
      (oraval ? " " + k(d.getHours()) + ":" + k(d.getMinutes()) : "");
  }
  function idopontokKitolt() {
    var most = new Date();
    var hatarido = new Date(most);
    var munkanap = 0;
    while (munkanap < 2) {
      hatarido.setDate(hatarido.getDate() + 1);
      if (hatarido.getDay() !== 0 && hatarido.getDay() !== 6) munkanap++;
    }
    var b = doboz.querySelector("[data-konz-bekuldve]");
    var h = doboz.querySelector("[data-konz-hatarido]");
    if (b) b.value = datum(most, true);
    if (h) h.value = datum(hatarido, false);
  }

  function nyit() {
    idopontokKitolt();
    var k = kapu();
    if (k) k.megjelent(NEV);
    fiokotBezar();
    var kosarMezo = doboz.querySelector("[data-konz-kosar]");
    var oldalMezo = doboz.querySelector("[data-konz-oldal]");
    if (kosarMezo) kosarMezo.value = kosarTetel || "";
    if (oldalMezo) oldalMezo.value = location.pathname;
    doboz.hidden = false;
    doboz.classList.add("active-modal-js", "mvt-konz--nyitva");
    document.documentElement.classList.add("mvt-konz-zar");
    var elso = doboz.querySelector("input:not([type=hidden])");
    if (elso) setTimeout(function () { elso.focus({ preventScroll: true }); }, 50);
    hirlevelUrlap(); // a captcha mar most kotodjon be, a bekuldesnel ne kelljen varni
    leiratkozik();
  }

  function bezar() {
    doboz.classList.remove("mvt-konz--nyitva", "active-modal-js");
    doboz.hidden = true;
    document.documentElement.classList.remove("mvt-konz-zar");
  }

  // --- hirlevel-feliratkozas (kulon pipa) ------------------------------------
  // A kviz bevalt mintaja (assets/movtech-kviz.js, kvizMentoForm): rejtett hirlevel-urlap a
  // body vegen (a modalon KIVUL, igy a form-ajax nem veszi at). A hCaptcha csak a mar bekotott
  // urlapot engedi, a bekotest focusin inditja, ezert mar nyitaskor kivaltjuk. A captcha a vegen
  // a prototipus submit()-jevel kuld: ott vesszuk at, es fetch-csel kuldjuk (nincs ujratoltes).
  // Hiba eseten csendben feladjuk: a visszahivas-keres ettol fuggetlenul mar beert.
  var HIRLEVEL_ID = "MovtechKonzHirlevel";
  var HIRLEVEL_CIMKEK = "konzultacio-kert,lokeshullam-erdeklodo";

  function hirlevelUrlap() {
    var f = document.getElementById(HIRLEVEL_ID);
    if (f) return f;
    f = document.createElement("form");
    f.id = HIRLEVEL_ID;
    f.method = "post";
    f.acceptCharset = "UTF-8";
    f.setAttribute("action", "/contact#" + HIRLEVEL_ID);
    f.style.display = "none";
    f.innerHTML =
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[email]" value=""><input type="hidden" name="contact[tags]" value="">';
    document.body.appendChild(f);
    try {
      f.elements["contact[email]"].dispatchEvent(new FocusEvent("focusin", { bubbles: true }));
    } catch (e) {}
    return f;
  }

  function feliratkoztat() {
    var pipa = doboz.querySelector("[data-konz-hirlevel]");
    var email = urlap && urlap.elements["contact[email]"];
    if (!pipa || !pipa.checked || !email || !email.value) return;
    var mire = urlap.querySelector('input[name="contact[Mire használná]"]:checked');
    var f = hirlevelUrlap();
    f.elements["contact[email]"].value = email.value.trim();
    f.elements["contact[tags]"].value =
      HIRLEVEL_CIMKEK + (mire ? ",konz:" + mire.value.toLowerCase().replace(/\s+/g, "-") : "");
    var probalt = 0;
    (function kuld() {
      // a captcha bekotese aszinkron; legfeljebb 5 mp-et varunk ra
      if (!f.dataset.hcaptchaBound && probalt++ < 25) { setTimeout(kuld, 200); return; }
      try {
        f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      } catch (e) {}
    })();
  }

  (function () {
    var elozo = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this.id !== HIRLEVEL_ID) return elozo.apply(this, arguments);
      fetch(this.getAttribute("action"), {
        method: "POST", body: new FormData(this), headers: { Accept: "text/html" }, credentials: "same-origin",
      })
        .then(function (r) {
          var ok = false;
          try { ok = new URL(r.url).searchParams.get("customer_posted") === "true"; } catch (e) {}
          if (window.console) console.info("[konzultacio] hirlevel-feliratkozas:", ok ? "OK" : "nem sikerult");
        })
        .catch(function () {});
    };
  })();

  function koszonet() {
    var k = kapu();
    if (k) k.kesz(NEV);
    feliratkoztat();
    try { sessionStorage.removeItem(KULDVE_KULCS); } catch (e) {}
    var panel = doboz.querySelector(".movtech-form-sent__text");
    if (panel) panel.textContent = KOSZONET;
    var szoveg = doboz.querySelector(".mvt-konz__szoveg");
    if (szoveg) szoveg.hidden = true;
    var cim = doboz.querySelector(".mvt-konz__cim");
    if (cim) cim.textContent = "Megkaptuk!";
  }

  // --- kilepesi szandek -----------------------------------------------------
  function egerKi(e) {
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 10) return;
    probal();
  }

  var utolsoY = window.scrollY;
  var utolsoIdo = Date.now();
  function gorgetes() {
    var most = Date.now();
    var y = window.scrollY;
    var dy = utolsoY - y; // pozitiv = felfele
    var dt = most - utolsoIdo || 1;
    // gyors felfele gorgetes, mikor mar lent jart az oldalon
    if (dy > 0 && dy / dt > 2.2 && utolsoY > window.innerHeight) probal();
    utolsoY = y;
    utolsoIdo = most;
    tetlensegUjra();
  }

  var tetlensegIdozito = null;
  function tetlensegUjra() {
    clearTimeout(tetlensegIdozito);
    tetlensegIdozito = setTimeout(probal, TETLENSEG_MS);
  }

  var erinto = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  function feliratkozik() {
    if (erinto) {
      window.addEventListener("scroll", gorgetes, { passive: true });
      ["touchstart", "keydown"].forEach(function (ev) {
        window.addEventListener(ev, tetlensegUjra, { passive: true });
      });
      tetlensegUjra();
    } else {
      document.addEventListener("mouseout", egerKi);
    }
  }
  function leiratkozik() {
    window.removeEventListener("scroll", gorgetes);
    document.removeEventListener("mouseout", egerKi);
    ["touchstart", "keydown"].forEach(function (ev) {
      window.removeEventListener(ev, tetlensegUjra);
    });
    clearTimeout(tetlensegIdozito);
  }

  // --- esemenyek --------------------------------------------------------------
  doboz.addEventListener("click", function (e) {
    if (e.target.closest("[data-konz-bezar]")) bezar();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !doboz.hidden) bezar();
  });
  if (urlap) {
    // capture fazis: a captcha a target fazisban allitja meg az esemenyt, ide meg eljut
    urlap.addEventListener("submit", function () {
      idopontokKitolt();
      try { sessionStorage.setItem(KULDVE_KULCS, "1"); } catch (e) {}
    }, true);
    urlap.addEventListener("movtech:form-success", koszonet);
  }

  // Gyari (ujratolteses) bekuldes utan: koszonet a popupban.
  var kuldve = false;
  try { kuldve = sessionStorage.getItem(KULDVE_KULCS) === "1"; } catch (e) {}
  if (kuldve && /[?&]contact_posted=true/.test(location.search)) {
    doboz.hidden = false;
    doboz.classList.add("mvt-konz--nyitva");
    if (urlap) urlap.hidden = true;
    var panel = document.createElement("p");
    panel.className = "mvt-konz__koszonet";
    panel.textContent = KOSZONET;
    doboz.querySelector(".mvt-konz__doboz").appendChild(panel);
    koszonet();
    return;
  }

  // Kozvetlen link (pl. a kurzusvevoknek szolo e-mailbol): ...#konzultacio
  // A kosartol es a napi korlattol fuggetlenul nyit, csak a „mar kitoltotte" szamit.
  if (location.hash === "#konzultacio") {
    var k = kapu();
    if (!k || !(k.allapot().kesz || {})[NEV]) {
      megnyitva = true;
      kosarEllenoriz().then(nyit);
      return;
    }
  }

  feliratkozik();
})();
